import { useSelector } from 'react-redux';
import Global from '../../../../../../store/global-selectors';
import { useGetNumberOfExtraUserSeats } from '../../../hooks/use-get-number-of-extra-user-seats';

/**
 * Zero
 * @constant {number}
 */
const ZeroUsers = 0;

const useGetCurrentPlanUserLimit = () => useSelector((state) => Global.selectSellerPlanInfo(state)?.plan?.userLimit?.limit ?? 0);

const useGetPromotionalPlanUserLimit = () =>
  useSelector((state) => {
    const promotionUpgrade = Global.selectSellerPromotionUpgrade(state);
    return promotionUpgrade?.targetBillingPlan?.userLimit?.limit ?? ZeroUsers;
  });

/**
 * Returns # of additional user seats above the current plan's base user limit
 * @returns {number}
 */
export const useGetCurrentAdditionalUserQuantity = () => useGetNumberOfExtraUserSeats() ?? ZeroUsers;

/**
 * Returns the # of current user seats on the current plan
 * @returns {number}
 */
export const useGetCurrentTotalUserSeats = () => {
  const currentAdditionalUserQuantity = useGetCurrentAdditionalUserQuantity();
  const userLimit = useGetCurrentPlanUserLimit();

  return userLimit + currentAdditionalUserQuantity;
};

/**
 * Returns the # of additional user seats to purchase above the new plan's base user limit
 * @returns {number}
 */
export const useGetAdditionalUsersCountForPromoPlan = () => {
  const currentTotalUsers = useGetCurrentTotalUserSeats();
  const promotionalPlanUserLimit = useGetPromotionalPlanUserLimit();

  const willPromotionalPlanProvisionSeatsForAllUsers = promotionalPlanUserLimit >= currentTotalUsers;

  const newAdditionalUserCount = currentTotalUsers - promotionalPlanUserLimit;
  return willPromotionalPlanProvisionSeatsForAllUsers ? ZeroUsers : newAdditionalUserCount;
};
